"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SHORTCUTS = void 0;
var moment_1 = __importDefault(require("moment"));
exports.DEFAULT_SHORTCUTS = [
    {
        dateRange: [
            (0, moment_1.default)("".concat((0, moment_1.default)().format('MM/DD/YYYY'), " 12:00 am")).toDate(),
            (0, moment_1.default)("".concat((0, moment_1.default)().format('MM/DD/YYYY'), " 11:59 pm")).toDate()
        ],
        label: 'Today',
        includeTime: true
    },
    {
        dateRange: [
            (0, moment_1.default)("".concat((0, moment_1.default)().format('MM/DD/YYYY'), " 12:00 am"))
                .subtract(1, 'day')
                .toDate(),
            (0, moment_1.default)("".concat((0, moment_1.default)().format('MM/DD/YYYY'), " 11:59 pm"))
                .subtract(1, 'day')
                .toDate()
        ],
        label: 'Yesterday',
        includeTime: true
    },
    {
        dateRange: [
            (0, moment_1.default)("".concat((0, moment_1.default)()
                .startOf('week')
                .add(1, 'day')
                .format('MM/DD/YYYY'), " 12:00 am"))
                .subtract(1, 'day')
                .toDate(),
            (0, moment_1.default)("".concat((0, moment_1.default)()
                .endOf('week')
                .add(1, 'day')
                .format('MM/DD/YYYY'), " 11:59 pm"))
                .subtract(1, 'day')
                .toDate()
        ],
        label: 'This week',
        includeTime: true
    },
    {
        dateRange: [
            (0, moment_1.default)("".concat((0, moment_1.default)()
                .startOf('week')
                .subtract(6, 'day')
                .format('MM/DD/YYYY'), " 12:00 am"))
                .subtract(1, 'day')
                .toDate(),
            (0, moment_1.default)("".concat((0, moment_1.default)()
                .endOf('week')
                .subtract(6, 'day')
                .format('MM/DD/YYYY'), " 11:59 pm"))
                .subtract(1, 'day')
                .toDate()
        ],
        label: 'Past week',
        includeTime: true
    },
    {
        dateRange: [
            (0, moment_1.default)("".concat((0, moment_1.default)()
                .startOf('month')
                .subtract(1, 'month')
                .format('MM/DD/YYYY'), " 12:00 am")).toDate(),
            (0, moment_1.default)("".concat((0, moment_1.default)()
                .endOf('month')
                .subtract(1, 'month')
                .format('MM/DD/YYYY'), " 11:59 pm")).toDate()
        ],
        label: 'Last month',
        includeTime: true
    },
    {
        dateRange: [
            (0, moment_1.default)("".concat((0, moment_1.default)()
                .startOf('month')
                .format('MM/DD/YYYY'), " 12:00 am")).toDate(),
            (0, moment_1.default)("".concat((0, moment_1.default)()
                .endOf('month')
                .format('MM/DD/YYYY'), " 11:59 pm")).toDate()
        ],
        label: 'This month',
        includeTime: true
    },
    {
        dateRange: [null, null],
        label: 'User Define',
        includeTime: true
    }
];
